import React from 'react';
import ReactDOM from 'react-dom';

import { CDN_ASSETS_URL } from 'constants/global';

import { ModalVideoPlayer } from 'components/ModalVideoPlayer';

type Props = {
  videoId: string;
  videoTitle: string;
  videoUrl: string;
  videoThumbnail: string;
  videoButtonText: string;
  cardTitle: string;
  cardText: string;
  buttonText: string;
};

export const VideoCard: React.FC<Props> = ({
  videoId,
  videoTitle,
  videoUrl,
  videoThumbnail,
  videoButtonText,
  cardTitle,
  cardText,
  buttonText,
}) => {
  const playVideo = () => {
    const placeholder = $('<div />').appendTo($('body'));
    ReactDOM.render(
      <ModalVideoPlayer type={'vimeo'} videoId={videoId} title={videoTitle} />,
      placeholder[0],
    );
  };
  return (
    <section className='video-card w-100 mb-2 mb-lg-4 d-flex flex-column flex-md-row align-items-center'>
      <div
        className='w-100 mb-2 mb-md-0 mr-md-2 d-flex js-monitor-visibility col-6 px-auto'
        style={{ maxWidth: '454px', minHeight: '277px' }}
      >
        <div className='stretch overflow-hidden'>
          <video
            preload='true'
            loop
            autoPlay
            muted
            style={{ objectFit: 'cover', maxHeight: '100%', minWidth: '100%' }}
          >
            <source src={`${CDN_ASSETS_URL}${videoUrl}`} type='video/mp4' />
            <source
              className='lazy-background'
              src={`${CDN_ASSETS_URL}${videoThumbnail}`}
              type='video/mp4'
            />
          </video>
        </div>
        <div className='absolute-overlay absolute-overlay--medium-dark'></div>
        <div
          className='d-flex justify-content-center align-items-center px-auto'
          style={{ minWidth: '100%', color: 'white' }}
        >
          <button
            onClick={playVideo}
            className='pos-rel btn--unstyled d-flex align-items-center text-left'
          >
            <div className='player__btn player__btn--icon icon-play'></div>
            <div
              className='key-value key-value--lg ml-1 lh-tight key-value__value'
              style={{
                maxWidth: '188px',
              }}
            >
              {videoButtonText}
            </div>
          </button>
        </div>
      </div>
      <div className='centered-section-container text-sm-left js-monitor-visibility pos-rel col-md-6 pl-0'>
        <h1 className='headline headline--medium text-left mb-mini'>{cardTitle}</h1>
        <p className='standfirst pt-mini mb-1 pb-mini animation-chain__2'>{cardText}</p>
        <div className='animation-chain__3 d-flex align-items-left flex-sm-row flex-column justify-content-center justify-content-sm-start'>
          <div className='mr-mini mr-sm-1 mb-1 mb-sm-0'>
            <a href={Routes.learn_more_index_path()} className='btn btn--border'>
              {buttonText}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
